<template>
  <div class="p-message-edit-confirm p-message-edit-confirm--details">
    <div class="c-title">
      <div class="c-title__text u-fs24">配信設定</div>
    </div>
    <div class="p-message-edit-confirm-list">
      <div class="p-message-edit-confirm-list__item">
        <div class="p-message-edit-confirm__title">プッシュメッセージの動作</div>
        <div v-if="message.require_interaction == 0" class="p-message-edit-confirm__text">一定時間後に自動最小化</div>
        <div v-if="message.require_interaction == 1" class="p-message-edit-confirm__text">ユーザーがアクションを起こすまで表示</div>
      </div>
      <div class="p-message-edit-confirm-list__item">
        <div class="p-message-edit-confirm__title">配信の設定</div>
        <div class="p-message-edit-confirm__text">{{ getDeliverString() }}</div>
      </div>
      <div v-if="message.message_deliver.deliver_type == 1" class="p-message-edit-confirm-list__item">
        <div class="p-message-edit-confirm__title">配信される日時</div>
        <div class="p-message-edit-confirm__text">{{ getSendStartDateTimeString() }}</div>
      </div>
      <template v-if="message.message_deliver.deliver_type == 3">
        <div class="p-message-edit-confirm-list__item">
          <div class="p-message-edit-confirm__title">配信時刻</div>
          <div class="p-message-edit-confirm__text">{{ getSendTimeString() }}</div>
        </div>
        <div class="p-message-edit-confirm-list__item">
          <div class="p-message-edit-confirm__title">配信開始</div>
          <div class="p-message-edit-confirm__text">{{ getSendStartDateString() }}</div>
        </div>
        <div class="p-message-edit-confirm-list__item">
          <div class="p-message-edit-confirm__title">配信終了</div>
          <div class="p-message-edit-confirm__text">{{ getSendEndDateString() }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    message: Object,
  },
  data: function () {
    return {
    };
  },
  methods: {
    getDeliverString: function() {
      let deliverType = this.message.message_deliver.deliver_type;
      let deliverString = '';
      if(deliverType == 1){ // 予約
        deliverString = '予約';
      } else if(deliverType == 3){ // 定期
        let regularType = this.message.message_deliver.regular_type;
        let dayOfTheWeek = ['日','月','火','水','木','金','土'];
        for(let day = 0 ; day < 7 ; day++){
          if(regularType.substring(day,day+1) == '1'){
            if(deliverString){
              deliverString += '・';
            }
            deliverString += dayOfTheWeek[day];
          }
        }
        deliverString = '定期配信：' + deliverString;
      } else if(deliverType == 4){ // 即時
        deliverString = '即時';
      }
      return deliverString;
    },
    getSendStartDateTimeString: function() {
      let sendStartDate = this.message.message_deliver.send_start_date;
      return this.getDisplayDate(sendStartDate) + ' ' + this.getDisplayTime(sendStartDate);
    },
    getSendStartDateString: function() {
      let sendStartDate = this.message.message_deliver.send_start_date;
      return this.getDisplayDate(sendStartDate);
    },
    getSendEndDateString: function() {
      let sendEndDate = this.message.message_deliver.send_end_date;
      return this.getDisplayDate(sendEndDate);
    },
    getSendTimeString: function() {
      return this.message.message_deliver.target_start_time;
    },
  },
}
</script>
